import React from 'react';
import type { SendEventT } from '../../analytics/types';
import ReviewSuggestionsSidePanelContent from './review-suggestions-side-panel-content';
import type { onFocusSuggestionFunctionT, ReviewSuggestionsDetailT, SUGGESTION_CATEGORY, SuggestionActionT, SuggestionDetailT } from './types';
import { SUGGESTION_ACTION } from './types';
type PropsT = {
  initialState: ReviewSuggestionsDetailT[];
  updateReviewSuggestionsPanelState: (id: string) => void;
  updateQuestionnaireAnswerWithLLMSuggestion: (error: SuggestionDetailT) => Promise<Error | string | undefined>;
  sendEvent: SendEventT;
  onEvaluate: () => Promise<void>;
  isLoading?: boolean;
  hasError?: boolean;
  isStale?: boolean;
  onFocusSuggestion?: onFocusSuggestionFunctionT;
  showNotification?: (notificationType: string, message: string) => void;
};
export type SuggestionWithCategoryT = SuggestionDetailT & {
  category: SUGGESTION_CATEGORY;
};
export const ReviewSuggestionsSidePanel = ({
  initialState,
  updateReviewSuggestionsPanelState,
  updateQuestionnaireAnswerWithLLMSuggestion,
  sendEvent,
  onEvaluate,
  isLoading,
  hasError,
  isStale,
  onFocusSuggestion
}: PropsT) => {
  const updateQuestionnaireHandler = async (error: SuggestionDetailT, action: SuggestionActionT) => {
    updateReviewSuggestionsPanelState(error.id);
    if (action === SUGGESTION_ACTION.ACCEPT) {
      await updateQuestionnaireAnswerWithLLMSuggestion(error);
    }
  };
  return <ReviewSuggestionsSidePanelContent initialState={initialState} onSuggestionAction={updateQuestionnaireHandler} sendEvent={sendEvent} onEvaluate={onEvaluate} panelState={{
    isLoading,
    hasError,
    isStale
  }} onFocusSuggestion={onFocusSuggestion} />;
};
export default ReviewSuggestionsSidePanel;